import React, { useEffect, useState } from "react";
import { LoadingOverlay, Notification } from "@mantine/core";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSalon } from "../../context/SalonContext";
import Overview from "./Overview";
import Settings from "./Settings";
import { useStripePayments } from "../../context/StripePaymentsContext";
import Devices from './Devices';

function PaymentsPage() {
  const { businessInfo } = useSalon();
  const [isLoading, setIsLoading] = useState(true);
  const { connectInstance, error } = useStripePayments();
  
  if (!businessInfo?.stripe_connect_account_is_onboarded) {
    return <Navigate to="/admin/settings/payments" />;
  }

  useEffect(() => {
    if (connectInstance || error) {
      setIsLoading(false);
    }
  }, [connectInstance, error]);
  
  const renderContent = () => {
    if (isLoading) {
      return <LoadingOverlay />;
    }

    if (error) {
      return <Notification color="red" title="Error" onClose={() => {}}>Failed to load the payments dashboard.  Try refreshing the page.  If the problem persists, contact support at contact@getpagoda.com</Notification>;
    }

    return (
        <Routes>
          <Route path="/" element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<Overview />} />
          <Route path="devices" element={<Devices />} />
          <Route path="settings" element={<Settings />} />
        </Routes>
      );
  }

  return renderContent();
}

export default PaymentsPage;
